/* eslint-disable react/display-name */
import React, { useEffect, useState, memo } from 'react'
import store from '@/store'
import { addrCreator, minusCreator } from '@/store/actionCreator'
import { connect } from 'react-redux'
import { fetchDataAction } from '@/store/counter'
import {
  NavLink,
  Outlet,
  Route,
  Router,
  Routes,
  Navigate
} from 'react-router-dom'
const state = (state: any) => ({
  age: state.counter.num
})

const listState = (state: any) => ({
  counter: state.number.counter
})

const disatchFunc = (dispatch: any) => ({
  addrCreator: (num: any) => {
    dispatch(addrCreator(num))
  },
  minusCreator(num: any) {
    dispatch(minusCreator(num))
  },
  delayCreator() {
    dispatch(fetchDataAction())
  }
})
const Profile = connect(
  state,
  disatchFunc
)((props: any) => {
  // console.log('Profile 刷新了')
  return (
    <>
      {/* <div>Profile数据:{props.age}</div> */}
      <div>Profile: 从store取到的age:{props.age}</div>
      <div>
        <button
          onClick={() => {
            props.addrCreator(props.age + 2)
          }}
        >
          增加
        </button>
      </div>
    </>
  )
})

const Home = connect(state)(
  memo((props: any) => {
    return (
      <>
        <div>Home: 从store取到的age:{props.age}</div>
        <Demo></Demo>
      </>
    )
  })
)

const Demo = memo(() => {
  // console.log('Demo要不要刷新')
  return <>Demo数据</>
})

const ListAdd = () => {
  return <>list add</>
}

const ListAlter = () => {
  return <>list 修改</>
}

function List(props: any) {
  const [num, setNum] = useState(110)
  const [show, setShow] = useState(false)

  useEffect(() => {
    //  delayCreator
    props?.delayCreator()
  }, [])
  const hanldeClick = () => {
    props.addrCreator(props.age + 1)
    // store.dispatch(addrCreator(num + 1))
  }
  const hanldeMinus = () => {
    // store.dispatch(addrCreator(num - 1))
    props.minusCreator(props.age - 1)
  }
  const getStore = () => {
    console.log(store.getState())
  }
  const goHome = () => {
    setShow(true)
  }
  return (
    <div>
      <div className="header">
        <NavLink to={'/list/add'}>添加</NavLink>
        <NavLink to={'/list/minus'}>减少</NavLink>
        <NavLink to={'/list/alter'}>修改</NavLink>
        <NavLink to={'/list/delete'}>删除</NavLink>
        <NavLink to={'/list/query'}>查询</NavLink>
      </div>
      我的列表页面
      <div>数据信息 {props.counter}</div>
      <div>
        <button onClick={getStore}>获取仓库数据</button>
        <button onClick={hanldeClick}>增加</button>
        <button onClick={hanldeMinus}>减少</button>
        <button
          onClick={() => {
            goHome()
          }}
        >
          切换至首页
        </button>
      </div>
      <div className="content">
        <Profile />
        <Home />
      </div>
      {show && <Navigate to={'/'} />}
      <Outlet></Outlet>
    </div>
  )
}

const MyList = connect(listState, disatchFunc)(List)

export default MyList
